export default __webpack_public_path__ + "7807c774bc0982ad749a476cf328180f.svg";